import { useState, useEffect } from 'react';

// Reference: https://usehooks.com/useDebounce/
/**
 * Accepts a value which can rapidly change, a timeout to determine its
 * stability, and returns the value when stable.
 * @param value The value which will change.
 * @param delay The timeout before considering the value stable.
 * @returns The value when stabilized.
 */
const useDebounce = (value, delay) => {
    // State and setters for debounced value
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
        // Update debounced value after delay
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);
        // Cancel the timeout if value changes (also on delay change or unmount)
        // This is how we prevent debounced value from updating if value is changed
        // within the delay period. Timeout gets cleared and restarted.
        return () => {
            clearTimeout(handler);
        };
    }, [setDebouncedValue, value, delay]);
    return debouncedValue;
};

export { useDebounce as default };
//# sourceMappingURL=index.js.map
